module.exports = __webpack_public_path__ + "img/img_bg.b5ed0e3.jpg";